import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=7b26495f&"
import script from "./task-detail.vue?vue&type=script&lang=js&"
export * from "./task-detail.vue?vue&type=script&lang=js&"
import style0 from "./task-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports